import { render, staticRenderFns } from "./ListaAlumnos.vue?vue&type=template&id=190a902c&scoped=true"
import script from "./ListaAlumnos.vue?vue&type=script&lang=js"
export * from "./ListaAlumnos.vue?vue&type=script&lang=js"
import style0 from "./ListaAlumnos.vue?vue&type=style&index=0&id=190a902c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a902c",
  null
  
)

export default component.exports